import { fetchLogin, fetchLoginInfo } from "@/api/user";
// import { Message } from "element-ui";
import { storage } from "@/utils";

const state = {
  has_fetch: false,
  has_login: false,
  token: "",
  token_type: "",
  username: "",
  avatar: "",
  hospital: ""
};

const getters = {};

const actions = {
  userInfo({ commit }) {
    return new Promise((resolve, reject) => {
      fetchLoginInfo()
        .then((res) => {
          const { data } = res;
          //   console.log(data, commit);

          const { name, image, hospital } = data;
          commit("SET_DATA", {
            payload: {
              has_fetch: true,
              has_login: true,
              username: name,
              avatar: image,
              hospital
            }
          });

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },

  userLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      fetchLogin(data)
        .then((res) => {
          const { data } = res;
          const { access_token, token_type } = data;

          storage.set("token", `${token_type} ${access_token}`);

          commit("SET_DATA", {
            payload: {
              has_login: true,
              token: access_token,
              token_type
            }
          });

          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const mutations = {
  resetUser(state) {
    state.has_login = false;
    state.token = "";
    state.token_type = "";
    state.username = "";
    state.avatar = "";
    state.hospital = "";
  },
  SET_DATA(state, payload) {
    for (let param in payload.payload) {
      state[param] = payload.payload[param];
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
